import { render, staticRenderFns } from "./TextCell.vue?vue&type=template&id=b123aa34&scoped=true&"
import script from "./TextCell.vue?vue&type=script&lang=js&"
export * from "./TextCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b123aa34",
  null
  
)

export default component.exports